import { Injectable, ViewContainerRef } from "@angular/core";
import { Overlay, ConnectionPositionPair, PositionStrategy, OverlayConfig, OverlayRef } from "@angular/cdk/overlay";
import { ComponentPortal, ComponentType } from "@angular/cdk/portal";
import { CellEditOverlay } from "../../components/metadataTable/infoGrid/cellEditOverlay.component";
import { Utilities } from "@tylertech/shared-module";
import { Subject, takeUntil } from "rxjs";

@Injectable({ providedIn: "root" })
export class CellEditCommandService
{
    private readonly destructor$ = new Subject<void>();
	overlayRef: OverlayRef;
    isOpen: boolean = false;

	constructor(
		private overlay: Overlay) { }

	Open(origin: any, component: ComponentType<CellEditOverlay>, viewContainerRef: ViewContainerRef, leaveCellEdit: (cancel: boolean) => void): void
    {
        this.isOpen = true;
		this.overlayRef = this.overlay.create(this.getOverlayConfig({ origin: origin}));
		const ref = this.overlayRef.attach(new ComponentPortal(component, viewContainerRef));
        ref.instance.doLeaveCellEdit.pipe(takeUntil(this.destructor$)).subscribe(leaveCellEdit);

		const dialogContainer = document.querySelector(".mat-dialog-container");
		if (!Utilities.IsNullOrUndefined(dialogContainer))
		{
			const cdkOverlayContainer = document.querySelector(".cdk-overlay-container");
			document.body.append(cdkOverlayContainer);
		}
	}

	Close(): void
    {
        this.isOpen = false;
		if (this.overlayRef)
        {
            this.destructor$.next();
            this.destructor$.complete();
			this.overlayRef.dispose();
			this.overlayRef = null;
		}
	}

	private getOverlayConfig({ origin}): OverlayConfig
    {
		return new OverlayConfig({
			hasBackdrop: false,
			backdropClass: "popover-backdrop",
			positionStrategy: this.getOverlayPosition(origin),
			scrollStrategy: this.overlay.scrollStrategies.close()
		});
	}

    private getOverlayPosition(origin: any): PositionStrategy
    {
		return this.overlay
			.position()
			.flexibleConnectedTo(origin)
			.withPositions(this.getPositions())
			.withPush(false);
	}

	private getPositions(): ConnectionPositionPair[]
    {
		return [
			{
				originX: "end",
				originY: "bottom",
				overlayX: "end",
				overlayY: "top"
			}
		];
	}
}
